import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { GroupSegmentNodePickerModule } from '@libs/src/group-segment-node-picker/group-segment-node-picker.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { GroupCustomSegmentSelectorModule } from '@main-client/src/app/group-segment-selector/group-custom-segment-selector.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { PrivateSegmentsSelectionsModule } from '@main-client/src/app/private-segments-selections/private-segments-selections.module';

import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { GroupMembershipDialogService } from '@main-client/src/app/group-membership-dialog/group-membership-dialog.service';

import { GroupMembershipDialogComponent } from './group-membership-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    GroupCustomSegmentSelectorModule,
    GroupMembershipPipeModule,
    GroupSegmentNodePickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    PrivateSegmentsSelectionsModule,
    ReactiveFormsModule,
    ToastModule,
    TranslationLookupModule,
    TtcButtonSharedModule,
  ],
  declarations: [GroupMembershipDialogComponent],
  providers: [GroupMembershipDialogService, GroupsBackend],
})
export class GroupMembershipDialogModule {}
